





























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ReloadButton from '@/components/BaseReloadButton.vue';
import Grid from '@/components/Grid.vue';
import GridFileItem from '@/components/GridFileItem.vue';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { FileActions } from '@/store/file/actions.enum';
import OpenFileMixin from '@/mixins/open-file';
import IntervalReloadMixin from '@/mixins/interval-reload';

export default Vue.extend({
  name: 'LastUploaded',

  mixins: [OpenFileMixin, IntervalReloadMixin],

  components: {
    ReloadButton,
    Grid,
    GridFileItem,
    LoadingSpinner,
  },

  computed: {
    ...mapGetters('file', { items: 'lastUploaded', loading: 'loading' }),
  },

  methods: {
    ...mapActions('file', {
      fetchLastUploaded: FileActions.FETCH_LAST_UPLOADED,
    }),

    reload() {
      this.fetchLastUploaded();
    },
  },
});
